'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var input = context.getElement('.' + context.className + '_Input');
  var trigger = context.getElement('.' + context.className + '_Trigger');

  input.addEventListener('keyup', validate);

  function validate() {
    var isValid = input.checkValidity();
    trigger.disabled = !isValid;
  }
}